import { getDefaultThemeColors } from "../utils/defaultThemeColors";
import { setActiveBranchId, clearActiveBranchId } from "../utils/branchStorage";

export const appReducer = (state, action) => {
  switch (action.type) {
    case "SET_ALGORITHM":
      localStorage.setItem("algorithm", "dark");
      return {
        ...state,
        algorithm: "dark",
      };

    case "SET_INITIALIZING":
      return {
        ...state,
        isInitializing: action.payload,
      };

    case "SET_AUTH_CHECKED":
      return {
        ...state,
        isAuthChecked: action.payload,
      };

    case "SET_THEME":
      // Guardar en localStorage para persistencia
      if (action.payload.appTitle) {
        localStorage.setItem("appTitle", action.payload.appTitle);
      }
      if (action.payload.globalLogoType) {
        localStorage.setItem("globalLogoType", action.payload.globalLogoType);
      }
      if (action.payload.algorithm) {
        localStorage.setItem("algorithm", action.payload.algorithm);
      }
      if (action.payload.primaryColor) {
        localStorage.setItem("primaryColor", action.payload.primaryColor);
      }
      if (action.payload.secondaryColor) {
        localStorage.setItem("secondaryColor", action.payload.secondaryColor);
      }
      if (action.payload.logo) {
        localStorage.setItem("logo", action.payload.logo);
      }
      if (action.payload.fontFamily) {
        localStorage.setItem("fontFamily", action.payload.fontFamily);
      }
      if (action.payload.fontSize) {
        localStorage.setItem("fontSize", action.payload.fontSize.toString());
      }
      if (action.payload.componentSize) {
        localStorage.setItem("componentSize", action.payload.componentSize);
      }
      if (action.payload.borderRadius !== undefined) {
        localStorage.setItem(
          "borderRadius",
          action.payload.borderRadius.toString(),
        );
      }
      if (action.payload.motion !== undefined) {
        localStorage.setItem(
          "motion",
          action.payload.motion ? "true" : "false",
        );
      }
      if (action.payload.compact !== undefined) {
        localStorage.setItem(
          "compact",
          action.payload.compact ? "true" : "false",
        );
      }

      // Guardar colores configurables
      if (action.payload.roleColors) {
        localStorage.setItem(
          "roleColors",
          JSON.stringify(action.payload.roleColors),
        );
      }
      if (action.payload.semanticColors) {
        localStorage.setItem(
          "semanticColors",
          JSON.stringify(action.payload.semanticColors),
        );
      }
      if (action.payload.gradientColors) {
        localStorage.setItem(
          "gradientColors",
          JSON.stringify(action.payload.gradientColors),
        );
      }
      if (action.payload.statusColors) {
        localStorage.setItem(
          "statusColors",
          JSON.stringify(action.payload.statusColors),
        );
      }

      return {
        ...state,
        globalLogoType:
          action.payload.globalLogoType || state.globalLogoType || "nucleus",
        primaryColor: action.payload.primaryColor || state.primaryColor,
        secondaryColor: action.payload.secondaryColor || state.secondaryColor,
        logo:
          action.payload.logo !== undefined ? action.payload.logo : state.logo,
        appTitle: action.payload.appTitle || state.appTitle,
        algorithm: action.payload.algorithm || state.algorithm,
        fontSize: action.payload.fontSize || state.fontSize,
        fontFamily: action.payload.fontFamily || state.fontFamily,
        componentSize: action.payload.componentSize || state.componentSize,
        borderRadius:
          action.payload.borderRadius !== undefined
            ? action.payload.borderRadius
            : state.borderRadius,
        motion:
          action.payload.motion !== undefined
            ? action.payload.motion
            : state.motion,
        compact:
          action.payload.compact !== undefined
            ? action.payload.compact
            : state.compact,
        roleColors: action.payload.roleColors || state.roleColors,
        semanticColors: action.payload.semanticColors || state.semanticColors,
        gradientColors: action.payload.gradientColors || state.gradientColors,
        statusColors: action.payload.statusColors || state.statusColors,
      };

    case "LOGIN": {
      // Soporta 'token', 'access' y 'access_token'
      const token =
        action.payload.token ||
        action.payload.access ||
        action.payload.access_token;
      const user = action.payload.user || null;
      const remember = action.payload.remember !== false; // Default true if undefined

      // Enforce dark theme for Super Admin
      const algorithm = "dark";

      // Persistencia inteligente: localStorage vs sessionStorage
      if (token) {
        if (remember) {
          localStorage.setItem("token", token);
          sessionStorage.removeItem("token");
        } else {
          sessionStorage.setItem("token", token);
          localStorage.removeItem("token");
        }
      }

      if (user) {
        if (remember) {
          localStorage.setItem("user", JSON.stringify(user));
          sessionStorage.removeItem("user");
        } else {
          sessionStorage.setItem("user", JSON.stringify(user));
          localStorage.removeItem("user");
        }
      }
      
      // ✅ OPTIMIZADO: Guardar defaultBranchId usando helper centralizado
      if (action.payload.defaultBranchId) {
        setActiveBranchId(action.payload.defaultBranchId, remember);
      }

      // Theme settings always in localStorage for UX consistency across sessions
      localStorage.setItem("algorithm", "dark");

      return {
        ...state,
        isAuth: !!token,
        token: token,
        user: user,
        algorithm: "dark",
      };
    }

    case "UPDATE":
      const localToken = localStorage.getItem("token");
      const sessionToken = sessionStorage.getItem("token");
      const token = localToken || sessionToken;

      const localUser = localStorage.getItem("user");
      const sessionUser = sessionStorage.getItem("user");
      const userStr = localUser || sessionUser;

      return {
        ...state,
        isAuth: !!token,
        token: token,
        user: userStr ? JSON.parse(userStr) : null,
      };

    case "SET_BRANCHES":
      return {
        ...state,
        branches: action.payload,
      };

    case "SET_DEFAULT_BRANCH":
      localStorage.setItem("defaultBranchId", action.payload?.toString() || "");
      return {
        ...state,
        defaultBranchId: action.payload,
        // Al establecer la predeterminada, si no hay una actual, usar esta
        currentBranchId: state.currentBranchId || action.payload,
      };

    case "SET_CURRENT_BRANCH":
      // ✅ OPTIMIZADO: Usar helper centralizado para guardar branch_id
      console.log("[appReducer] SET_CURRENT_BRANCH:", action.payload);
      if (action.payload) {
        const remember = localStorage.getItem("token") !== null;
        setActiveBranchId(action.payload, remember);
      }
      return {
        ...state,
        currentBranchId: action.payload,
      };

    case "SET_BRANCH_THEME":
      // Aplicar configuración temática de la sucursal
      const theme = action.payload;
      const isSuperAdmin =
        state.user?.is_superuser || state.user?.type_user === "ADM";

      const displayAppName =
        theme.app_name || theme.branch_name || state.appTitle;

      if (displayAppName) {
        localStorage.setItem("appTitle", displayAppName);
      }
      if (theme.primary_color) {
        localStorage.setItem("primaryColor", theme.primary_color);
      }
      if (theme.secondary_color) {
        localStorage.setItem("secondaryColor", theme.secondary_color);
      }
      if (theme.logo_url) {
        localStorage.setItem("logo", theme.logo_url);
      }
      if (theme.font_size) {
        localStorage.setItem("fontSize", theme.font_size.toString());
      }
      if (theme.component_size) {
        localStorage.setItem("componentSize", theme.component_size);
      }
      if (theme.borderRadius !== undefined) {
        localStorage.setItem("borderRadius", theme.borderRadius.toString());
      }
      if (theme.motion !== undefined) {
        localStorage.setItem("motion", theme.motion ? "true" : "false");
      }
      if (theme.compact !== undefined) {
        localStorage.setItem("compact", theme.compact ? "true" : "false");
      }
      // Solo guardar algorithm si NO es superadmin (SuperAdmin siempre es dark)
      localStorage.setItem("algorithm", "dark");

      // Guardar colores configurables desde tema de sucursal
      if (theme.role_colors) {
        localStorage.setItem("roleColors", JSON.stringify(theme.role_colors));
      }
      if (theme.semantic_colors) {
        localStorage.setItem(
          "semanticColors",
          JSON.stringify(theme.semantic_colors),
        );
      }
      if (theme.gradient_colors) {
        localStorage.setItem(
          "gradientColors",
          JSON.stringify(theme.gradient_colors),
        );
      }
      if (theme.status_colors) {
        localStorage.setItem(
          "statusColors",
          JSON.stringify(theme.status_colors),
        );
      }

      // IMPORTANTE: La configuración de la sucursal SIEMPRE tiene prioridad
      // Si viene primary_color de la sucursal, usarlo. Si no, mantener el actual
      const newPrimaryColor =
        theme.primary_color !== undefined && theme.primary_color !== null
          ? theme.primary_color
          : state.primaryColor;

      // FIX: Logo debe venir explícitamente del tema de sucursal
      // Si no viene logo_url, limpiar para evitar mostrar logo de otra sucursal
      const newLogo = theme.logo_url !== undefined ? theme.logo_url : null;
      return {
        ...state,
        currentBranchTheme: theme,
        appTitle: displayAppName,
        primaryColor: newPrimaryColor,
        secondaryColor: theme.secondary_color || state.secondaryColor,
        logo: newLogo,
        fontSize: theme.font_size || state.fontSize,
        componentSize: theme.component_size || state.componentSize,
        borderRadius:
          theme.borderRadius !== undefined
            ? theme.borderRadius
            : state.borderRadius,
        motion: theme.motion !== undefined ? theme.motion : state.motion,
        compact: theme.compact !== undefined ? theme.compact : state.compact,
        algorithm: "dark",
        roleColors: theme.role_colors
          ? { ...state.roleColors, ...theme.role_colors }
          : state.roleColors,

        semanticColors: theme.semantic_colors
          ? { ...state.semanticColors, ...theme.semantic_colors }
          : state.semanticColors,
        gradientColors: theme.gradient_colors
          ? { ...state.gradientColors, ...theme.gradient_colors }
          : state.gradientColors,
        statusColors: theme.status_colors
          ? { ...state.statusColors, ...theme.status_colors }
          : state.statusColors,
      };

    case "LOGOUT": {
      // No limpiar configuraciones de tema al hacer logout
      const appTitle = localStorage.getItem("appTitle");
      const algorithm = "dark";
      const primaryColor = localStorage.getItem("primaryColor");
      const secondaryColor = localStorage.getItem("secondaryColor");
      const logo = localStorage.getItem("logo");
      const globalLogoType =
        localStorage.getItem("globalLogoType") || "nucleus";
      const fontSize = localStorage.getItem("fontSize");
      const fontFamily = localStorage.getItem("fontFamily");
      const componentSize = localStorage.getItem("componentSize");
      const borderRadius = localStorage.getItem("borderRadius");
      const motion = localStorage.getItem("motion");
      const compact = localStorage.getItem("compact");

      // Cargar colores configurables desde localStorage
      const savedRoleColors = localStorage.getItem("roleColors");
      const savedSemanticColors = localStorage.getItem("semanticColors");
      const savedGradientColors = localStorage.getItem("gradientColors");
      const savedStatusColors = localStorage.getItem("statusColors");

      const defaultColors = getDefaultThemeColors();

      localStorage.removeItem("token");
      localStorage.removeItem("user");
      // ✅ OPTIMIZADO: Usar helper centralizado para limpiar branch_id
      clearActiveBranchId();

      return {
        ...state,
        isAuth: false,
        token: null,
        user: null,
        branches: [], // Limpiar sucursales al hacer logout
        currentBranchId: null, // Limpiar sucursal actual
        // Mantener configuraciones de tema
        appTitle: appTitle || "ERP - Smart APR",
        algorithm: "dark",
        primaryColor: primaryColor || state.primaryColor || "#1890ff",
        secondaryColor: secondaryColor || state.secondaryColor || "#ffffff",
        logo: logo || state.logo || null,
        globalLogoType,
        fontSize: fontSize ? parseInt(fontSize) : 14,
        fontFamily: fontFamily || state.fontFamily,
        componentSize: componentSize || "middle",
        borderRadius: borderRadius ? parseInt(borderRadius) : 6,
        motion: motion !== "false",
        compact: compact === "true",
        roleColors: savedRoleColors
          ? JSON.parse(savedRoleColors)
          : state.roleColors || defaultColors.roleColors,
        semanticColors: savedSemanticColors
          ? JSON.parse(savedSemanticColors)
          : state.semanticColors || defaultColors.semanticColors,
        gradientColors: savedGradientColors
          ? JSON.parse(savedGradientColors)
          : state.gradientColors || defaultColors.gradientColors,
        statusColors: savedStatusColors
          ? JSON.parse(savedStatusColors)
          : state.statusColors || defaultColors.statusColors,
      };
    }

    default:
      return state;
  }
};
